<script setup lang="ts">
import LabelBase from '@/components/label/LabelBase.vue'
import PhIcon from '@/components/PhIcon.vue'
import { useRouter } from 'vue-router'

// router & route
const router = useRouter()
</script>

<template>
  <div
    @click="router.push({ name: 'sale-create' })"
    class="flex gap-3 mt-1 px-5 py-2 bg-stone-100 dark:bg-stone-900 rounded-xl cursor-pointer transition-colors duration-150"
  >
    <div class="self-center text-green-500">
      <ph-icon name="plus-circle" :size="18"></ph-icon>
    </div>
    <div>
      <label-base size="sm" class="block whitespace-nowrap">Create Transaction</label-base>
    </div>
  </div>
</template>

<style scoped></style>
